import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalDescription, Loader, List } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import AnagraficaService from 'shared/services/api/anagrafica';

export default class StoricoPrivacyModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      privacyLogData: [],
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && this.props.isOpen !== prevProps.isOpen) {
      this.loadPrivacyHistory();
    }
  }

  loadPrivacyHistory = () => {
    this.setState({ isLoading: true }, () =>
      AnagraficaService.getPrivacyLogByAnagrafica(this.props.anagraficaId)
        .then((data) => {
          this.setState({ privacyLogData: data._embedded.privacy_logger });
        })
        .finally(() => this.setState({ isLoading: false }))
    );
  };

  transformNewlines = (text) => (
    <div>
      {text.split('\n').map((lineText, index) => (
        <span>
          {lineText}
          {index < text.split('\n').length - 1 && <br />}
        </span>
      ))}
    </div>
  );

  render() {
    return (
      <Modal closeIcon open={this.props.isOpen} onClose={this.props.onClose} size="tiny">
        <Modal.Header>Storico privacy</Modal.Header>
        <Modal.Content>
          {this.state.isLoading ? (
            <div>
              <Loader inline centered active />
            </div>
          ) : (
            <ModalDescription>
              {_.isEmpty(this.state.privacyLogData) ? (
                <p style={{ fontWeight: 'bold' }}>Nessuno storico privacy presente</p>
              ) : (
                <List divided relaxed>
                  {this.state.privacyLogData.map((privacyData) => (
                    <List.Item>
                      <List.Icon name="user circle outline" size="large" verticalAlign="middle" />
                      <List.Content>
                        <List.Header>
                          {privacyData.nominativoCollaboratore}
                          {' - '}
                          {privacyData.createdBy}
                        </List.Header>
                        <List.Description>
                          Data: {moment.unix(privacyData.dataLog).format('DD/MM/YYYY HH:mm')}
                          <br />
                          {this.transformNewlines(privacyData.descrizione)}
                        </List.Description>
                      </List.Content>
                    </List.Item>
                  ))}
                </List>
              )}
            </ModalDescription>
          )}
        </Modal.Content>
      </Modal>
    );
  }
}

StoricoPrivacyModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  anagraficaId: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/StoricoPrivacyModal/index.js